<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Informasi Umum</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Judul Informasi">
                        <b-form-input v-model="input.namaInformasi" name="namaInformasi" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Konten Informasi">
                        <b-form-textarea id="textarea" v-model="input.konten" name="gadaiKondisi" rows="3"
                            max-rows="6"></b-form-textarea>
                    </b-form-group>
                    <b-form-group label="Jenis Informasi">
                        <b-form-select v-model="input.jenisInformasi" name="jenisInformasi" :options="jenisInformasi" value-field="id" text-field="name" required>
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label="File Informasi">
                        <b-form-file
                            class="file-informasi-input"
                            v-model="input.fileInformasi" name="fileInformasi"
                            :state="Boolean(input.fileInformasi)"
                            placeholder="Choose a file"
                            drop-placeholder="Drop file here..."
                            required
                            multiple></b-form-file>
                    </b-form-group>
                    <b-form-group label="Ditujukan kepada">
                        <b-form-checkbox-group v-model="input.roleIds" name="gadaiPenambahanSpesifikasiJenisElek">
							<b-form-checkbox class="d-block" v-for="item in role" v-bind:key="item.id" :value="item.id">
								{{ item.name }}
							</b-form-checkbox>
						</b-form-checkbox-group>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="InformasiUmumSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Informasi Umum" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput Informasi umum ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-Informasi-umum',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input: {
                namaInformasi: "",
                jenisInformasi: null,
                konten:"",
                fileInformasi: null,
                roleIds: []
            },
            jenisInformasi:[],
            role: [],

        }
    },
    methods: {
        //----------------- Fungsi Inisialisasi -----------------

        getUnreadCount() {
        // Make a request using the axios instance with the interceptor
        this.$axios.get('informasi-umum/count-unreads')
            .then(response => {
                this.$store.state.readNotifstore.readCount = response.data.id
            //   this.count = response.data.id
            })
            .catch(error => {
            console.error(error)
            })
        },

        init() {

            this.initStatus = 0

            let getJenisInformasi = this.$axios.get('informasi-umum/jenis').then(response => {
                this.jenisInformasi = response.data
            })

            let getRole = this.$axios.get('role/').then(response => {
                this.role = response.data
            }) 

            Promise.all([getJenisInformasi,getRole]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Role -----------------

            payload.append("title", this.input.namaInformasi)
            payload.append("content", this.input.konten)
            payload.append("jenisId", this.input.jenisInformasi)
            for(let item of this.input.fileInformasi){
                payload.append("attachments", item)
            }
            for(let role of this.input.roleIds) {
                payload.append("roleIds", role)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("informasi-umum/", payload).then(response => {
                this.getUnreadCount()
                this.$helper.setFlash(`Informasi Umum baru telah berhasil dibuat!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-input")
        }

    },

    created(){
        this.init()
    }

}
</script>

<style scoped>
::v-deep .file-informasi-input .custom-file {
    height: calc(1.5em + 0.75rem + 2px);
}

::v-deep .file-informasi-input .custom-file-label {
    height: calc(1.5em + 0.75rem + 2px);
    display: block;
    padding-right: 7rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

::v-deep .file-informasi-input .custom-file-label::after {
    height: 100%;
}
</style>
